import {Component, Input, OnInit} from '@angular/core';
import {
  Aangifte,
  BokkzAlgDataService,
  IncomeTaxEntity,
  LijfrentePremie
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-premies-kind',
  templateUrl: './premies-kind.component.html',
  styleUrls: ['./premies-kind.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class PremiesKindComponent implements OnInit {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;

    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte

    public isDefAangifte = {} as boolean;

    private focusedElementId: string | null = null;

    public showSpinner = true;

    public premieKind = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.premieKind = this.fb.group({
            betaaldePremieKind:
                this.fb.array<LijfrentePremie>([])
        })
    }

    get betaaldePremiekind(): FormArray {
        return this.premieKind.get('betaaldePremieKind') as FormArray;
    }

    addRijLoonPremieKind(): void {
        this.betaaldePremiekind.push(this.createPremieKindFormGroup());
    }

    verwijderRijPremieKind(index: number): void {
        this.betaaldePremiekind.removeAt(index);
        this.premieKind.updateValueAndValidity()
        this.premieKind.markAsDirty()
        this.saveForm();
    }



    createPremieKindFormGroup(premie?: LijfrentePremie): FormGroup {
        return this.fb.group(({
            omschrijving: premie ? premie?.omschrijving : undefined,
            bedrag: premie ? premie.bedrag : undefined,
            polisnummer: premie ? premie.polisnummer : undefined
        } as LijfrentePremie));
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner
                    this.premieKind.reset()
                    this.updateForm();
                });
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(
          filter(
            (event: Event): event is NavigationEnd =>
              event instanceof NavigationEnd,
          ),
        )
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
      if (this.isDefAangifteSubscription) {
          this.isDefAangifteSubscription.unsubscribe();
      }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.premieKind.dirty
  }

    private updateForm(): void {
        let premieKindLijst = this.aangifte?.box1?.uitgavenVoorInkomensvoorzieningen?.lijfrentePremiesBetaaldKind || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                premieKindLijst = this.aangifte?.partnerAangifte?.box1?.uitgavenVoorInkomensvoorzieningen?.lijfrentePremiesBetaaldKind || [];
            }
        });

        const formArrayKind = this.premieKind.get('betaaldePremieKind') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
        while (formArrayKind != null && formArrayKind.length > premieKindLijst.length) {
            formArrayKind.removeAt(formArrayKind.length - 1);
        }

        // Add or update controls
        for (let k = 0; k < premieKindLijst.length; k++) {
            if (k < formArrayKind.length) {
                // Update existing control
                const control = formArrayKind.at(k) as FormGroup;
                control.patchValue(premieKindLijst[k]);
            } else {
                // Add new control
                const formGroup = this.createPremieKindFormGroup(premieKindLijst[k]);
                formArrayKind.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        if (!this.partnerBoolean) {

            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                box1: {
                    ...this.aangifte.box1,
                    uitgavenVoorInkomensvoorzieningen: {
                        ...this.aangifte.box1?.uitgavenVoorInkomensvoorzieningen,
                        lijfrentePremiesBetaaldKind: this.premieKind.value.betaaldePremieKind
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    box1: {
                        ...this.aangifte.partnerAangifte?.box1,
                        uitgavenVoorInkomensvoorzieningen: {
                            ...this.aangifte.partnerAangifte?.box1?.uitgavenVoorInkomensvoorzieningen,
                            lijfrentePremiesBetaaldKind: this.premieKind.value.betaaldePremieKind
                        }
                    },
                },
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
    }
}

